import { render, staticRenderFns } from "./FieldAge.vue?vue&type=template&id=5fccf22c&"
import script from "./FieldAge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FieldAge.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fccf22c')) {
      api.createRecord('5fccf22c', component.options)
    } else {
      api.reload('5fccf22c', component.options)
    }
    module.hot.accept("./FieldAge.vue?vue&type=template&id=5fccf22c&", function () {
      api.rerender('5fccf22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldAge/FieldAge.vue"
export default component.exports